import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  IMyKnownError,
  IPaginatedListResponse,
  REQUEST_LIFE_CICLE,
} from 'interfaces/requests';
import { parsedMailingRuleToStrategyItem } from './helpers';
import { IStrategyNavigationModeState } from './interface';
import { IMailingRuleParsedToStrategyActionsItem } from 'interfaces/Strategy';
import { expandMailingRule } from 'modules/mailingRule/helpers';
import { IMailingRule } from 'interfaces/MailingRule';
import { get, MICROSERVICES } from 'api';
import endpoints from './endpoint';

const initialState = {
  lists: {},
  loading: REQUEST_LIFE_CICLE.IDLE,
} as IStrategyNavigationModeState;

export const getMailingsAction = createAsyncThunk<
  {
    [key: string]: IMailingRuleParsedToStrategyActionsItem[];
  },
  undefined,
  { rejectValue: IMyKnownError }
>(
  'mailingRuleByServiceCategoryList/getMailings',
  async (_, { rejectWithValue }) => {
    try {
      const result = await get<IPaginatedListResponse<IMailingRule>>(
        MICROSERVICES.STRATEGIES,
        {
          url: endpoints.listMailingRules(),
          params: {
            limit: 9999999,
            offset: 0,
            status: ['CREATED', 'ACTIVE'],
          },
        },
      );

      const mailingRuleList = result.data.values;

      const parsedMailingRuleList = {} as {
        [key: string]: IMailingRuleParsedToStrategyActionsItem[];
      };

      mailingRuleList.forEach((mailingRule) => {
        if (!parsedMailingRuleList[mailingRule.serviceCategory._id])
          parsedMailingRuleList[
            mailingRule.serviceCategory._id
          ] = [] as IMailingRuleParsedToStrategyActionsItem[];

        const expandedMailingRule = expandMailingRule(mailingRule);
        const parsedMailingRule = parsedMailingRuleToStrategyItem(
          expandedMailingRule,
        );

        parsedMailingRuleList[mailingRule.serviceCategory._id].push(
          parsedMailingRule,
        );
      });
      return parsedMailingRuleList;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const strategyModeSlice = createSlice({
  name: 'strategy',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMailingsAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
      return state;
    });
    builder.addCase(getMailingsAction.rejected, (state) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
      return state;
    });
    builder.addCase(getMailingsAction.fulfilled, (state, { payload }) => {
      state.lists = payload;
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
      return state;
    });
  },
});
const { reducer } = strategyModeSlice;
export default reducer;
